<script>
    import EventHeader from "./EventHeader.svelte";
    import EventText from "./EventText.svelte";
    import ExternalUrls from "./ExternalUrls.svelte";
    import EventAgeRestrictions from "./EventAgeRestrictions.svelte";
    import EventButtons from "./EventButtons.svelte";
    import EventLineUp from "./EventLineUp.svelte";
    import EventTicketMessage from "./EventTicketMessage.svelte";
    import EventCarousel from "./EventCarousel.svelte";
    import EventVideo from "./EventVideo.svelte";

    export let event;
</script>

<EventHeader {event}/>
<EventAgeRestrictions {event}/>

<div class="container">
    <EventButtons {event}/>
    <EventTicketMessage {event}/>
    <EventLineUp {event}/>
    <EventCarousel {event}/>
    <EventText {event}/>
    <ExternalUrls {event}/>
    <EventVideo {event}/>
</div>

<svelte:head>
    <title>{event.name}</title>
</svelte:head>

<style>
    .container {
        position: relative;
    }
    .btn {
        right: 0px;
        z-index: 100;
    }
</style>